export enum ConsentMethods {
	BY_USER = 'BY_USER',
	BY_CONTRACT = 'BY_CONTRACT',
	BY_QUESTIONNAIRE = 'BY_QUESTIONNAIRE',
	BY_CONTACT_FORM = 'BY_CONTACT_FORM'
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/components/base/client/consent-list/consent-list.model.ts